import { Home, TrendingUp, PlusSquare, Calendar, Mail, Target, FileText, User, Settings, type LucideIcon } from 'lucide-react';

export interface NavItem {
  id: string;
  label: string;
  icon: LucideIcon;
  view: string;
  bottomNav: boolean;
  enabled: boolean;
}

export const clientNavItems: NavItem[] = [
  { id: 'home',      label: 'Home',      icon: Home,       view: 'home',      bottomNav: true,  enabled: true },
  { id: 'progress',  label: 'Progress',  icon: TrendingUp, view: 'progress',  bottomNav: true,  enabled: true },
  { id: 'log',       label: 'Log',       icon: PlusSquare, view: 'log',       bottomNav: true,  enabled: true },
  { id: 'history',   label: 'History',   icon: Calendar,   view: 'history',   bottomNav: true,  enabled: true },
  { id: 'messages',  label: 'Messages',  icon: Mail,       view: 'messages',  bottomNav: true,  enabled: false },
  { id: 'goals',     label: 'Goals',     icon: Target,     view: 'goals',     bottomNav: false, enabled: true },
  { id: 'documents', label: 'Documents', icon: FileText,   view: 'documents', bottomNav: false, enabled: true },
  { id: 'profile',   label: 'Profile',   icon: User,       view: 'profile',   bottomNav: false, enabled: true },
  { id: 'settings',  label: 'Settings',  icon: Settings,   view: 'settings',  bottomNav: false, enabled: true },
];
